import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog } from 'Models'
import { TagModel } from 'Pages/admin'
import { Callback } from 'Types/utilTypes'

export type TagState = {
	tag: ResponseCatalog<TagModel>
	random_tag: ResponseCatalog<TagModel>
	requestParams: RequestParams
	editId: number | null
	dataItem: { [key: string]: string }
}

export const tagInitialState: TagState = {
	tag: new ResponseCatalog<TagModel>(),
	random_tag: new ResponseCatalog<TagModel>(),
	requestParams: new RequestParams(),
	editId: null,
	dataItem: {},
}

export namespace tagNS {
	export type getAllTag = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type getRandomTag = PayloadAction<{ params?: RequestParams }>
	export type createTag = PayloadAction<{ tag: TagModel; callback: Callback }>
	export type updateTag = PayloadAction<{ tag: TagModel; id: number }>
	export type deleteTag = PayloadAction<{ id: number }>
	export type setAllTag = PayloadAction<ResponseCatalog<TagModel>>
	export type setAllRandomTag = PayloadAction<ResponseCatalog<TagModel>>
	export type setParams = PayloadAction<RequestParams>
	export type setEditId = PayloadAction<number>
	export type setDataItem = PayloadAction<{ [key: string]: string }>
}

export const tagSlice = createSlice({
	name: 'tag',
	initialState: tagInitialState,
	reducers: {
		getAll: (state, action: tagNS.getAllTag) => {},
		setAll: (state, action: tagNS.setAllTag) => {
			state.tag = action.payload
		},
		setAllRandomTag: (state, action: tagNS.setAllRandomTag) => {
			state.random_tag = action.payload
		},
		setParams: (state, action: tagNS.setParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.tag = new ResponseCatalog<TagModel>()
			state.requestParams = new RequestParams()
		},
		getRandomTag: (state, action: tagNS.getRandomTag) => {},
		createOne: (state, action: tagNS.createTag) => {},
		updateOne: (state, action: tagNS.updateTag) => {},
		deleteOne: (state, action: tagNS.deleteTag) => {},
		setEditId: (state, action: tagNS.setEditId) => {
			state.editId = action.payload
		},
		setDataItem: (state, action: tagNS.setDataItem) => {
			state.dataItem = action.payload
		},
	},
})
